import { NotificationPreferencesPage } from '../Notifications/NotificationPreferencesPage';

/**
 * Preferences Page
 * Manages notification preferences and can be expanded in the future to include other preference settings
 */
export default function PreferencesPage() {
  return <NotificationPreferencesPage />;
}

